// PII scrubber for Sentry events. Duplicated in customer-web/src/utils —
// there is no shared frontend package; keep the two copies in sync.

const PII_FIELDS = new Set([
  'email',
  'phone',
  'firstname',
  'lastname',
  'dob',
  'dateofbirth',
  'ssn',
  'password',
  'token',
]);

const REDACTED = '[Redacted]';

function scrubPII(value: unknown, seen = new WeakSet<object>()): void {
  if (!value || typeof value !== 'object') return;
  if (seen.has(value as object)) return;
  seen.add(value as object);

  if (Array.isArray(value)) {
    value.forEach(item => scrubPII(item, seen));
    return;
  }

  const obj = value as Record<string, unknown>;
  Object.keys(obj).forEach(key => {
    if (PII_FIELDS.has(key.toLowerCase())) {
      obj[key] = REDACTED;
    } else {
      scrubPII(obj[key], seen);
    }
  });
}

export function scrubSentryEvent<
  T extends { extra?: unknown; contexts?: unknown },
>(event: T): T {
  scrubPII(event.extra);
  scrubPII(event.contexts);
  return event;
}
